import React from 'react'
import { pages } from '../pageNumberForm'


const FormHeader = ({ page }) => {
    return (
        <>
            <h1>
                {page === pages.firstPage
                    ? 'Get started'
                    : 'Invite professionals to the job'
                }
            </h1>
            <p className="formStepDescr">
                {page === pages.firstPage
                    ? "Post your creative project and see who's available to help."
                    : "Choose your dream team and invite the right people and their skills to the job. This might be friends or colleagues. You can even post your project publicly to broaden your network."
                }
            </p>
        </>
    )
}

export default FormHeader